import { render, staticRenderFns } from "./BTabItem.vue?vue&type=template&id=04af617a&"
import script from "./BTabItem.vue?vue&type=script&lang=ts&"
export * from "./BTabItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports